export default __webpack_public_path__ + "static/media/pdfBigLogo.54a27bf0.svg";